import type { FlowCode } from "@/constants";
import type {
  ApiResponse,
  FlowFormNo,
  FlowNode,
  MyStartedTaskListItem,
  NowFlowNode,
  PageResponse,
  PassFlowSchema,
  QueryStartedTaskInfoSchema,
  QueryTaskInfoSchema,
  StartFlowSchema,
  TaskInfoListItem,
} from "@/types/apis";
import request from "@/utils/request";

/**
 * 生成表单编号
 * @param flowCode
 * @returns
 */
export const generateFlowFormCode = (flowCode: FlowCode) =>
  request.get<ApiResponse<FlowFormNo>>("/view/generate/process/code", {
    params: {
      flowCodeEnums: flowCode,
    },
  });

/**
 * 发起流程
 * @param data
 * @returns
 */
export const startFlow = (data: StartFlowSchema) =>
  request.post<ApiResponse>("/view/start", data);

/**
 * 发起流程
 * @param data
 * @returns
 */
export const passFlow = (
  taskId: number,
  data: PassFlowSchema["flowParamsDto"],
) =>
  request.post<ApiResponse>("/view/pass", data, {
    params: {
      taskId,
    },
  });

/**
 * 获取流程文件id
 */
export const getFlowFileId = (data: { fileUrl: string }) =>
  request.post<ApiResponse<number>>("/oss/upload/file", data);

/**
 * 查询当前流程历史记录-审批记录
 */
export const getFlowHistoryByIns = (insId: number) =>
  request.get<ApiResponse<FlowNode[]>>(`/view/getHisByIns/${insId}`);

/**
 * 查询当前用户待办任务
 */
export const getReceivedTasks = (data: QueryTaskInfoSchema) =>
  request.get<PageResponse<TaskInfoListItem>>("/view/getTaskInfo", {
    params: data,
  });

/**
 * 查询当前用户发起的任务
 */
export const getStartedTasks = (data: QueryStartedTaskInfoSchema) =>
  request.get<PageResponse<MyStartedTaskListItem>>("/view/getInstanceByMe", {
    params: data,
  });

/**
 * 上传供应商流程业务文件
 * @param data 供应商流程业务文件数组
 * @returns 返回上传结果
 */
export const uploadSupplierFlowBusinessFiles = (
  data: Array<{
    fileUrl: string;
    fileName: string;
    fileType: number;
  }>,
) => request.post<ApiResponse>("/oss/upload/files", data);

/**
 * 获取当前流程节点
 */
export const getNowNodeByInsId = (insId: number) =>
  request.get<ApiResponse<NowFlowNode[]>>(`/view/getNowNodeByInsId/${insId}`);
